import { supabase } from './supabaseClient';

export async function fetchAllUserData() {
    // Fetch sessions with related data
    const { data: sessions, error } = await supabase
        .from('sessions')
        .select(`
      *,
      product:products (
        name,
        strain:strains (name, type),
        brand:brands (name)
      )
    `)
        .order('created_at', { ascending: false });

    if (error) throw error;
    return sessions;
}

export function convertToCSV(data: any[]): string {
    if (!data || data.length === 0) return '';

    // Flatten the data for CSV
    const flatData = data.map(item => ({
        Date: new Date(item.created_at).toLocaleDateString(),
        Time: new Date(item.created_at).toLocaleTimeString(),
        Product: item.product?.name || 'Unknown',
        Brand: item.product?.brand?.name || 'Unknown',
        Strain: item.product?.strain?.name || 'Unknown',
        Type: item.product?.strain?.type || 'Unknown',
        Method: item.consumption_method || '',
        Dosage: `${item.dosage_amount || 0} ${item.dosage_unit || ''}`,
        Rating: item.overall_rating || '',
        Effect_Anxiety: item.anxiety || '',
        Effect_Body: item.body_high || '',
        Effect_Head: item.head_high || '',
        Effect_Creative: item.creativity || '',
        Notes: item.notes ? `"${item.notes.replace(/"/g, '""')}"` : '', // Escape quotes
        Session_Cost: item.session_cost?.toFixed(2) || '0.00'
    }));

    const headers = Object.keys(flatData[0]);
    const rows = flatData.map(obj => headers.map(header => obj[header as keyof typeof obj]).join(','));

    return [headers.join(','), ...rows].join('\n');
}

export function downloadCSV(csvContent: string, filename: string) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
